import {Component, OnDestroy, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {ToastrService} from 'ngx-toastr';
import {permissions} from '../../permissions';
import {Page} from '../../model/page';
import {PagedData} from '../../model/paged-data';
import {ConsoleApplicationService} from '../../services/console-application.service';
import {IConsoleApplication} from './ConsoleApplication';
import {ConsoleLogThreadManager} from './ConsoleLogThreadManager';
import * as _ from 'lodash';
import {GridFiltersService} from '../../services/grid.filters.service';
import {IResponse} from '../../model/server_response';
import {Title} from '@angular/platform-browser';

@Component({
    templateUrl: 'console-applications.component.html',
    styleUrls: ['./console-applications.component.scss'],
    providers: [
        ConsoleApplicationService,
        GridFiltersService
    ]
})
export class ConsoleApplicationsComponent implements OnInit, OnDestroy {

    public loading = false;
    public permissions = permissions;
    private filters: { [key: string]: string; } = {};
    private consoleApplications: Array<object> = [];
    public consoleLog;

    page = new Page();
    rows = new Array<IConsoleApplication>();
    alias = {};

    constructor(
        private router: Router,
        private consoleApplicationService: ConsoleApplicationService,
        private toastr: ToastrService,
        private gridFiltersService: GridFiltersService,
        private title: Title
    ) {
        this.page.pageNumber = 0;
        this.page.size = 10;
        this.consoleLog = new ConsoleLogThreadManager(consoleApplicationService);
        this.title.setTitle('Admin - Console Applications');
    }

    ngOnDestroy(): void {
        this.consoleLog.destroyInterval();
    }


    createConsoleApplication(id): void {
        this.router.navigate(['console-applications/create/' + id]);
    }


    editConsoleApplication(record): void {
        this.router.navigate(['console-applications/edit/' + record.CL1_ID]);
    }

    ngOnInit() {
        this.loading = true;
        this.consoleApplicationService.preloadData().subscribe( data => {
            this.prepareData(data);
            this.setPage({offset: 0});
        });
    }

    prepareData(data) {
        this.consoleApplications = data.consoleApplications.map( consoleApplication => {
            return {
                CL1_ID: consoleApplication.CL1_ID,
                CL1_NAME: consoleApplication.CL1_NAME
            }
        });
    }

    getData() {
        this.loading = true;
        this.setPage({offset: this.page.pageNumber});
    }

    setPage(pageInfo) {
        this.page.pageNumber = pageInfo.offset;

        this.serverCall(this.page).subscribe(result => {
            const pagedData = this.getPagedData(this.page, result.count, result.data);
            this.page = pagedData.page;
            this.rows = pagedData.data;
            this.alias = result.alias;
            window.dispatchEvent(new Event('resize'));
            this.loading = false;
        },
        error => {
            this.loading = false;
            window.dispatchEvent(new Event('resize'));
            this.toastr.error('Timeout occurred', 'Service Error', {
                timeOut: 3000,
            });
        });
    }

    onSort(event) {
        // TODO get sort working
        this.page.sortParams = {};
        if (!_.isEmpty(event.sorts)) {
            for (const item of event.sorts) {
                this.page.sortParams[item.prop] = item.dir;
            }
        }
        this.ngOnInit();
    }

    private getPagedData(page: Page,  count: number, consoleApplicationsData: Array<IConsoleApplication>): PagedData<IConsoleApplication> {
        const pagedData = new PagedData<IConsoleApplication>();
        pagedData.data = consoleApplicationsData;
        page.totalElements = count;
        page.totalPages = page.totalElements / page.size;
        pagedData.page = page;
        return pagedData;
    }

    serverCall(page: Page): Observable<IResponse<IConsoleApplication>> {
        return this.consoleApplicationService.getConsoleApplications(page);
    }

    onSubmit() {

        const filters = this.gridFiltersService.prepare( this.filters );

        let reload = false;
        const keys = Object.keys(filters).concat(Object.keys(this.page.filterParams));
        for (const key of keys) {
            if (this.page.filterParams[key] != filters[key]) {
                reload = true;
                break;
            }
        }

        if (reload) {
            this.page.filterParams = filters;
            this.getData();
        }
    }

}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/console-applications/console-applications.component.ts